import * as React from 'react';

import { Formatters, Messages } from '../../../codegen/Localize';
import { FavoriteToggle } from '../../../common/react/components/FavoriteToggle/FavoriteToggle';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { IViewInfo } from '../../../ts/models/IViewInfo';
import { PopularExplanation, SimiliarUsersExplanation } from '../../../ts/models/IViewRecommendationInfo';
import { IRelatedContentInfo } from '../../../ts/models/resourceInfoParts';
import { RelatedContentInfoContext } from '../../contexts/TelemetryContexts';
import { TooltipAnchor } from '../Tooltips/TooltipAnchor';
import { ViewTooltip } from '../Tooltips/ViewTooltip';
import { CardTextAndLink } from './CardTextAndLink';
import { CardViewStyles } from './CardViewStyles';
import { ContentCard, ContentCardProps, getContentUrlForItem } from './ContentCard';
import { DetailsTooltipStyles } from './DetailsTooltipStyles';
import { Thumbnail } from './Thumbnail';

export class RecommendationCard extends ContentCard {

  public render() {
    return (
      <div className={`${CardViewStyles.Card} ${CardViewStyles.RecommendationCard}`}>
        {this.renderRecommendationExplanation()}
        <TooltipAnchor tooltipContent={this.renderTooltipContent}
          width={DetailsTooltipStyles.Width}
          onShowTooltip={this.handleShowTooltip}
          title={Messages.viewTooltipTitle()}
          disableTooltip={this.props.disableTooltip}
        >
          <Thumbnail navigateUrl={getContentUrlForItem(this.props.content, this.props.urls)}
            defaultImageUrl={imgPath('spaces_card_view.svg')}
            thumbnailImageUrl={this.props.content.thumbnailUrl}
            hoveredOrSelected={this.props.hoveredOrSelected}
            allowDragAndDrop={this.props.allowDragAndDrop}
          />
        </TooltipAnchor>
        <div className={CardViewStyles.ActionRow} style={{marginBottom: '-3px'}}>
          <span data-tb-test-id="rec-item-name" className={CardViewStyles.ActionRowName} title={this.props.content.name}>
            {this.props.content.name}
          </span>
          {this.renderViewsCountForVizRec()}
          <span>
            <FavoriteToggle isTabbable={true}
              isFavorite={this.props.content.favorite}
              onAddFavorite={() => this.props.addContentFavorite({ ...this.props.content, contentType: 'view' })}
              onRemoveFavorite={() => this.props.removeContentFavorite({ ...this.props.content, contentType: 'view' })} />
          </span>
          {this.renderFavoritesCountForVizRec()}
          {this.renderActionsMenu()}
        </div>
        {this.renderParentWorkbookLink()}
      </div>
    );
  }

  private renderParentWorkbookLink = () => {
    const workbook = (this.props.content as IViewInfo).workbook;
    if (workbook) {
      const relatedInfo = {relatedContentId: workbook.id, relatedContentType: 'workbook'} as IRelatedContentInfo;
      return <div className={CardViewStyles.CardDescription}>
        <RelatedContentInfoContext.Provider value={relatedInfo} >
          <CardTextAndLink
            text={''}
            url={this.props.urls.workbookUrl(workbook.id)}
            urlDisplayName={workbook.name}
            marginLeft={-9}
            isRecommendationType={true}
          />
        </RelatedContentInfoContext.Provider>
      </div>;
    }
  }

  private renderViewsCountForVizRec = () => {
    const viewsCount = (this.props.content as IViewInfo).usageInfo.hitsTotal;
    if (Number.isInteger(viewsCount)) {
      return (
        <React.Fragment>
          <span className={CardViewStyles.VizRecViewsIcon} title={Messages.viewIconTooltip()}></span>
          <span className={CardViewStyles.VizRecViewsCount}>{Formatters.formatCountInRecommendationCard(viewsCount)}</span>
        </React.Fragment>
      );
    }
  }

  private renderFavoritesCountForVizRec = () => {
    const favoritesCount = (this.props.content as IViewInfo).usageInfo.favoritesTotal;
    if (Number.isInteger(favoritesCount)) {
      return <span className={CardViewStyles.VizRecFavoritesCount}>{Formatters.formatCountInRecommendationCard(favoritesCount)}</span>;
    }
  }

  private renderRecommendationExplanation = () => {
    let explanationShape: string = '';
    let explanationText = '';
    if (this.props.content.explanationType === PopularExplanation) {
      explanationShape = 'ribbon_Trending.svg';
      explanationText = Messages.vizRecommendationsPopularExplanation();
    } else if (this.props.content.explanationType === SimiliarUsersExplanation) {
      explanationShape = 'ribbon_ForYou.svg';
      explanationText = Messages.vizRecommendationsSimiliarUsersExplanation();
    }

    if (explanationShape && explanationText) {
      /* eslint-disable jsx-a11y/alt-text */
      return <div data-tb-test-id="recommendation-explanation">
        <span className={this.props.hoveredOrSelected
          ? CardViewStyles.RecommendationCardTextHover
          : CardViewStyles.RecommendationCardText}>{explanationText}</span>
        <img src={imgPath(explanationShape)}
          className={this.props.hoveredOrSelected
            ? CardViewStyles.RecommendationCardShapeHover
            : CardViewStyles.RecommendationCardShape} />
      </div>;
    }
  }

  private renderTooltipContent = () => {
    return <ViewTooltip content={this.props.content}
      urls={this.props.urls} />;
  }
}
